'use client';

import StokeText from '@/components/ui-feat/stoke-text';
import clsx from 'clsx';
import { AudioId, useAudioHelper } from '@/utils/audio-hepler';
interface TitleBarProps {
  leftTitle: string;
  rightTitle?: string | React.ReactNode;
  rightTitleClassName?: string;
  colors?: Array<string>;
  onClickRightTitle?: () => void;
}

export default function TitleBar({
  leftTitle,
  rightTitle,
  onClickRightTitle,
  rightTitleClassName,
  colors = ['#FFDA46', '#DF8C00'],
}: TitleBarProps) {
  const { playAudio } = useAudioHelper({ id: AudioId.ButtonClick });
  // 分离第一个字母和剩余文字
  const firstLetter = leftTitle.charAt(0).toUpperCase();
  const remainingText = leftTitle.slice(1);

  const handleClickRightTitle = () => {
    playAudio();
    onClickRightTitle?.();
  };

  const isLetter = /^[A-Za-z]$/.test(firstLetter as string || '');
  return (
    <header className={clsx("flex items-center justify-between leading-[15px] mb-[15px] pr-[12px]", rightTitleClassName)}>
      {
        isLetter ? (
          <div className="flex items-center h-[15px]">
            {
              firstLetter && (
                <div className={clsx('flex items-baseline text-white text-[16px]')}>
                  <StokeText
                    lineGradient={colors}
                    containerClass="font-monitalic"
                  >{firstLetter}</StokeText>
                  <span className="text-primary text-sm font-semibold pl-[1px]">
                    {remainingText}
                  </span>
                </div>
              )
            }
          </div>
        ) : (
          <div className={clsx('flex items-baseline text-white font-semibold text-[16px]')}>
            {leftTitle}
          </div>
        )
      }
      <div
        className="text-accent-blue text-s font-medium active:scale-90"
        onClick={handleClickRightTitle}
      >{rightTitle}</div>
    </header>
  );
}